import {get} from 'lodash';

export default (state = {}, {bonuses, formattedCurrentPeriod}: any) => {
  return {
    ...state,
    bonuses: {
      ...get(state, 'bonuses', {}),
      [formattedCurrentPeriod]: bonuses,
    },
  };
};
